import { Component, EventEmitter, Input, Output } from '@angular/core'
import { ButtonModule } from 'primeng/button'
import { SafeResourceUrl } from '@angular/platform-browser'
import { Router, RouterModule } from '@angular/router'

import { AnalyticsService } from '@app/core/_services/analytics.service'
import { FmDebounceClickDirective } from '@app/shared/directives/fm-debounce-click.directive'
import { TooltipModule } from 'primeng/tooltip'

@Component({
    selector: 'fm-right-panel-header',
    templateUrl: './right-panel-header.component.html',
    styleUrls: ['./right-panel-header.component.scss'],
    standalone: true,
    imports: [ButtonModule, RouterModule, FmDebounceClickDirective, TooltipModule],
})
export class RightPanelHeaderComponent {
    @Input() showBackButton = false
    @Input() showReloadButton = false
    @Input() panelOpen = true
    @Input() sendToMainPanelUrl: SafeResourceUrl | null = null
    @Output() back = new EventEmitter<void>()
    @Output() togglePanel = new EventEmitter<void>()
    @Output() refreshSelected = new EventEmitter<void>()

    constructor(
        private router: Router,
        private analyticsService: AnalyticsService,
    ) {}

    onBack(): void {
        this.back.emit()
    }

    onClickRefresh(): void {
        this.refreshSelected.emit()
    }

    onTogglePanel(): void {
        this.togglePanel.emit()
    }

    onClickSendToMainPanel(): void {
        this.analyticsService.logSendTOMainPanelClick(this.sendToMainPanelUrl)
        this.router.navigate([this.sendToMainPanelUrl])
        this.back.emit()
    }
}
